import { PublicClientApplication } from '@azure/msal-browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import AccountProvider from './authentication/AccountProvider';
import { configuration } from './authentication/authConfig';
import App from './App';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
// const pca = new PublicClientApplication(configuration);
const pca = await PublicClientApplication.createPublicClientApplication(configuration);

root.render(
    <MsalProvider instance={pca}>
        <AccountProvider>
            <StrictMode>
                <RouterProvider router={App} />
            </StrictMode>
        </AccountProvider>
    </MsalProvider>,
);
